import { render, staticRenderFns } from "./wantHouse.vue?vue&type=template&id=c369f6f6&scoped=true"
import script from "./wantHouse.vue?vue&type=script&lang=js"
export * from "./wantHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c369f6f6",
  null
  
)

export default component.exports